import {Pipe, PipeTransform} from '@angular/core';
import {TIYN_TENGE_SCALE_FACTOR} from '../constants';

@Pipe({
    name: 'tiynTenge',
    standalone: false
})
export class TiynTengePipe implements PipeTransform {

    transform(value: number): string {
        if (!value) {
            return null;
        }
        return (value / TIYN_TENGE_SCALE_FACTOR).toFixed(2);
    }
}
